<template lang="pug">
  Default(
    :footer='false'
  )
</template>

<script>
import defaultPage from "@/mixins/pages/default.mixin";

export default {
  mixins: [defaultPage()],
  async mounted() {
    await this.$store.dispatch("user/logout");
    this.$router.push("/").catch(() => {});
  }
};
</script>

<style></style>
